import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import homePage from '@/views/HomePage/HomePage'
import organization from '@/views/Organization/Organization'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'organization',
      component: organization
    },
    // {
    //   path: '/',
    //   name: 'HelloWorld',
    //   component: HelloWorld
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js